import React, { useMemo } from 'react'
import DatePicker from 'components/DatePicker'
import filterPanelStyles from 'components/Filters/FilterPanel/filter-panel.module.scss'
import format from 'utils/dateFns/format'
import PropTypes from 'prop-types'
import { parse } from 'date-fns'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

const DatepickerFilter = ({ filterManager, name }) => {
  const { filters = {}, configuration, updateFilter } = filterManager
  const breakpoints = useBreakpoint()

  const [start, end] = useMemo(
    () => configuration?.[name].names || [],
    [configuration, name],
  )

  const [storedPresetsNames, setPresetsName] = useLocalStorage(
    configuration[name].lsPrefix ?? 'filterDatepickerPresets',
    {},
  )

  const parsedValue = useMemo(() => {
    return {
      startDate: filters?.[start]
        ? parse(filters[start], 'yyyy-MM-dd', new Date())
        : null,
      endDate: filters?.[end]
        ? parse(filters[end], 'yyyy-MM-dd', new Date())
        : null,
      key: 'selection',
    }
  }, [filters, start, end])

  return (
    breakpoints.md && (
      <DatePicker
        hasBackdrop
        buttonClassName={filterPanelStyles['datepicker-button']}
        minDate={new Date(2018, 0, 1)}
        maxDate={new Date()}
        value={parsedValue ?? undefined}
        onChange={(value) => {
          //write datepicker preset_name for current pathname
          value.preset_name &&
            setPresetsName({
              ...storedPresetsNames,
              [global.location.pathname]: value.preset_name,
            })
          //update filter state with selected date range
          updateFilter([
            {
              fieldName: start,
              value: format(value.startDate, 'yyyy-MM-dd'),
            },
            {
              fieldName: end,
              value: format(value.endDate, 'yyyy-MM-dd'),
            },
          ])
        }}
      />
    )
  )
}

DatepickerFilter.propTypes = {
  filterManager: PropTypes.object,
  name: PropTypes.string,
}

export default DatepickerFilter
